import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import { store } from "store";
var LoginView = /** @class */ (function (_super) {
    tslib_1.__extends(LoginView, _super);
    function LoginView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = "username";
        _this.username = "";
        _this.pin = "";
        _this.error = "";
        _this.pinSentMessageVisible = false;
        _this.requestingPin = false;
        return _this;
    }
    LoginView.prototype.routed = function () {
        store.page.title = this.$t("loginView.title");
        store.page.showTopNav = true;
    };
    LoginView.prototype.checkUsername = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.error = "";
                        this.requestingPin = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.post("authentication/login", { username: this.username })];
                    case 2:
                        data = (_a.sent()).data;
                        this.requestingPin = false;
                        if (data.status == "NonexistentUser") {
                            this.error = this.$t("loginView.nonexistentUser");
                            return [2 /*return*/];
                        }
                        if (data.status == "PinSent")
                            this.pinSentPopup();
                        //this.pinSentMessageVisible = true;
                        this.state = "pin";
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.error = this.$t("loginView.pinRequestFailed");
                        this.requestingPin = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoginView.prototype.login = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.error = "";
                        if (!this.pin) {
                            this.error = this.$t("loginView.enterPin");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, axios.post("authentication/login", {
                                deviceId: store.identity.deviceId,
                                username: this.username,
                                pin: this.pin
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        if (data.status == "NonexistentUser") {
                            this.state == "username";
                            return [2 /*return*/];
                        }
                        if (data.status == "PinInvalid") {
                            this.error = this.$t("loginView.pinInvalid");
                            return [2 /*return*/];
                        }
                        if (!(data.status == "PinExpired")) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.sendPin()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3:
                        store.identity.accessToken = data.accessToken;
                        localStorage.setItem("accessToken", data.accessToken);
                        this.$router.replace("/");
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginView.prototype.sendPin = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post("authentication/sendpin", { username: this.username })];
                    case 1:
                        data = (_a.sent()).data;
                        if (data.status == "NonexistentUser") {
                            this.error = "User has disappeared. Try again.";
                            this.state = "username";
                            return [2 /*return*/];
                        }
                        this.pinSentPopup();
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginView.prototype.pinSentPopup = function () {
        this.$popup(this.$t("loginView.pinSentTopic"), this.$t("loginView.pinSent"));
    };
    LoginView = tslib_1.__decorate([
        Component
    ], LoginView);
    return LoginView;
}(Vue));
export default LoginView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/LoginView.vue
// module id = 65
// module chunks = 0